import { SharedLocData } from "../../types/types";


export enum LocalizationEvents {
    LANGUAGE_CHANGED = "language_changed",
}

export class Localization 
{
    /**
     * Current locales, reported by browser
     * > an array, ordered by priority (first is best, if you can find local match)
     */
    protected static navigatorLocales: string[];

    /**
     * Associative table between locale codes and actual selected language index in settings,
     * same index as in @see AppLocalStorage.GetLanguageIndex/SetLanguageIndex
     */
    protected static localeStringsToLanguageIndex: number[];

    /**
     * For events like 'language changed'
     */
    protected static eventEmitter:Phaser.Events.EventEmitter;



    public static GetEmitter(): Phaser.Events.EventEmitter
    {
        return this.eventEmitter;
    }

    public static Init(): void
    {
        this.navigatorLocales = this.GetNavigatorLanguages();
        this.eventEmitter = new Phaser.Events.EventEmitter();

        // override in subclass
    }

    /**
     * Returns browser's locales
     * @see https://stackoverflow.com/questions/673905/how-to-determine-users-locale-within-browser#674570
     * 
     * Used in localization and number formatting (eg @see myNumber.toLocaleString(myLocale))
     * @see https://medium.com/@paoferretti/javascript-how-to-format-numbers-to-locale-with-currency-960b49434226
     * 
     * @returns 
     */
    protected static GetNavigatorLanguages(): string[]
    {
        if (navigator.languages != undefined) {
            return [...navigator.languages];
        }
        return [];
    }
}